import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://resumefuel.xyz/resume/src/backend/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (data.success) {
        setIsSuccess(true);
        setMessage("Login successful. Redirecting...");
        setTimeout(() => navigate("/admin/dashboard"), 1000);
      } else {
        setIsSuccess(false);
        setMessage(data.message || "Invalid credentials.");
      }
    } catch (err) {
      setIsSuccess(false);
      setMessage("Login failed. Please try again.");
    }
  };

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "350px",
        margin: "100px auto",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Admin Login</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          autoComplete="username"
          style={{
            width: "93%",
            padding: "10px",
            margin: "10px 0",
            borderRadius: "4px",
            height: "30px",
          }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required    
          autoComplete="current-password"
          style={{
            width: "93%",
            padding: "10px",
            margin: "10px 0",
            borderRadius: "4px",
            height: "30px",
          }}
        />
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginTop: "10px",
          }}
        >
          Login
        </button>
      </form>

      {message && (
        <div
          style={{
            marginTop: "20px",
            padding: "10px",
            backgroundColor: isSuccess ? "#d4edda" : "#f8d7da",
            color: isSuccess ? "#155724" : "#721c24",
            borderRadius: "4px",
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
}

export default AdminLogin;
